import {ValidatorFn, Validators} from '@angular/forms';

export class Validadores {
	static matricula(): ValidatorFn
	{
		return Validators.pattern(/([0-9 ]{4}[A-Z]{3})|([A-Z]{1}[0-9]{4}[A-Z]{2})|([A-Z]{2}[-]{1}[0-9]{4}[-]{1}[A-Z]{1})|([A-Z]{2}[-]{1}[0-9]{5})|([E ]{1}[0-9 ]{4}[ A-Z]{3})|[A-Z]{4}[[0-9]{4}[a-z]{1}|[A-Z]{3}[0-9]{4}[A-Z]{1}|[A-Z]{2}[0-9]{6}|[C]{1}[0-9]{4}[B-Z]{3}|[E]{1}[.|·]{1}[0-9]{4}|[E-Z]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}|[CGPC][0-9]{4}[A-Z]{1}/);
	}
}
